import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function createLightningGroupAPI(group) {
  const url = `${AWS_API_URL}/lighting/group`;

  return postRequest(url, mapDataForBackend(group), await authorize());
}
